import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { SpacesService } from 'account-hybrid/common/components/spaces';
import { Environment, ENVIRONMENT_TOKEN } from 'account-hybrid/core/environment.service';
import { TransactionsImportComponent } from '../components/transactions-import/transactions-import.component';

export interface TransactionsImportRowError {
    rowNumber: number;
    message: string;
}

export interface TransactionsImportResult {
    rowsImported: number;
    rowsRejected: number;
    errors: TransactionsImportRowError[];
}

@Injectable({ providedIn: 'root' })
export class TransactionsImportService {
    constructor(private dialog: MatDialog,
                private http: HttpClient,
                private spacesService: SpacesService,
                @Inject(ENVIRONMENT_TOKEN) private environment: Environment) {
    }

    openDialog() {
        this.dialog.open(TransactionsImportComponent, {
            panelClass: 'ft2',
            width: '100%',
            backdropClass: '-light',
        });
    }

    upload(file: File): Observable<TransactionsImportResult> {
        const contextUuid = this.spacesService.hasCompanyContext() && !this.spacesService.isPropertySpace()
            ? this.spacesService.getCompanyUuid()
            : this.spacesService.getPropertyUuid();
        const propertyUuid = this.spacesService.getPropertyUuid();

        const formData = new FormData();
        formData.append('formFile', file, file.name);

        return this.http.post<TransactionsImportResult>(
            `${this.environment.apiBaseUrl}/${contextUuid}/properties/${propertyUuid}/transactions-import`,
            formData
        );
    }
}
